export const renderBackNavigationText = (url: string) => {
  const keywords = ['tasks', 'projects', 'task', 'project']
  const splitUrl = url.split('/')
  let matchedSegment = ''

  keywords.forEach(keyword => {
    if (!matchedSegment) {
      matchedSegment = splitUrl.find(urlSegment => urlSegment === keyword) || ''
    }
  })

  return `Back${matchedSegment ? ' to ' + matchedSegment : ''}`
}
